import { observer } from "mobx-react-lite";
import { FC } from "react";
import { OAuthCardError } from "@/pages/oauth-consent/oauth-card-error";

import { OAuthConsentPageForm } from "@/pages/oauth-consent/oauth-consent-page-form";

interface OAuthConsentPageContentProps {
  redirectUri: string | null;
  clientId: string | null;
  state: string | null;
  scopeStr: string | null;
  responseType: string | null;
}

export const OAuthConsentPageContent: FC<OAuthConsentPageContentProps> = observer(
  ({ redirectUri, clientId, state, scopeStr, responseType }) => {
    if (!redirectUri || !clientId || !state || !scopeStr || responseType !== "code") {
      return <OAuthCardError />;
    }

    return (
      <OAuthConsentPageForm
        redirectUri={redirectUri}
        clientId={clientId}
        state={state}
        scopeStr={scopeStr}
      />
    );
  }
);
